import {
  ADD_SERVICE_ITEM_TAB,
  ADD_SYSTEM_TAB,
  BANK_TAB,
  BRANCH_GROUP_TAB,
  CAC_ROLES_TAB,
  CAC_USER_TAB,
  CONFIGURATION_TAB,
  CUSTOMER_TAB,
  DISTRIBUTOR_TAB,
  DOCTORS_TAB,
  ENTITY_TAB,
  GENERATE_OTP_TAB,
  HEALTH_STATUS_TAB,
  HSN_TAB,
  MANUFACTURER_GROUP_TAB,
  MANUFACTURER_TAB,
  PRODUCTS_TAB,
  PROFESSION_TAB,
  REPORTS_DISCOUNT_PROGRAM,
  REPORTS_DISCOUNT_SLAB,
  REPORTS_FREQUENCY_SLAB_TAB,
  REPORTS_MEDICINE_WISE_STOCK_AUDIT,
  REPORTS_MEDICINE_WISE_STOCK_REQUEST,
  REPORTS_MEDICINE_WISE_STOCK_TRANSFER,
  REPORTS_STOCK_AUDIT,
  REPORTS_STOCK_REQUEST,
  REPORTS_STOCK_TRANSFER,
  RETAILER_REPORTS_TAB,
  ROLES_TAB,
  SPECIALITY_TAB,
  STOCK_AUDIT_TAB,
  TRANSPORTATION_TAB,
  USERS_TAB,
} from "../../framework/tab/tabUtilsConstants";

export const privilege_groups = [
  {
    groupId: "ROLES_MANAGEMENT",
    groupLabel: "Roles Management",
    privileges: [
      {
        id: RETAILER_REPORTS_TAB,
        label: "Retailer",
        desc: "Access to Retailer screen",
      },
      { id: USERS_TAB, label: "Users", desc: "Access to Users screen" },
      { id: ROLES_TAB, label: "Roles", desc: "Access to pharmacy Roles screen" },
      {
        id: CAC_USER_TAB,
        label: "CAC Users",
        desc: "Access to CAC Users screen",
      },
      {
        id: CAC_ROLES_TAB,
        label: "CAC Users Roles",
        desc: "Access to CAC Users Roles screen",
      },
    ],
  },
  {
    groupId: "MASTER",
    groupLabel: "Master",
    privileges: [
      {
        id: PRODUCTS_TAB,
        label: "Products Master",
        desc: "Access to Products Master screen",
      },
      {
        id: DOCTORS_TAB,
        label: "Doctor Master",
        desc: "Access to Doctor Master screen",
      },
      {
        id: ENTITY_TAB,
        label: "Entity/Family Master",
        desc: "Access to Entity/Family Master screen",
      },
      {
        id: CUSTOMER_TAB,
        label: "Customer Master",
        desc: "Access to Customer Master screen",
      },
      { id: BANK_TAB, label: "Bank Master", desc: "Access to Bank Master screen" },
      { id: HSN_TAB, label: "HSN Master", desc: "Access to HSN Master screen" },
      {
        id: DISTRIBUTOR_TAB,
        label: "Distributor Master",
        desc: "Access to Distributor Master screen",
      },
      {
        id: PROFESSION_TAB,
        label: "Profession Master",
        desc: "Access to Profession Master screen",
      },
      {
        id: TRANSPORTATION_TAB,
        label: "Transport Master",
        desc: "Access to Transport Master screen",
      },
      {
        id: ADD_SERVICE_ITEM_TAB,
        label: "Service Item Master",
        desc: "Access to Service Item Master screen",
      },
      {
        id: MANUFACTURER_TAB,
        label: "Manufacturer Master",
        desc: "Access to Manufacturer Master screen",
      },
      {
        id: MANUFACTURER_GROUP_TAB,
        label: "Manufacturer Group Master",
        desc: "Access to Manufacturer Group Master screen",
      },
      {
        id: BRANCH_GROUP_TAB,
        label: "Branch Group Master",
        desc: "Access to Branch Group Master screen",
      },
      {
        id: SPECIALITY_TAB,
        label: "Speciality Master",
        desc: "Access to Speciality Master screen",
      },
    ],
  },
  {
    groupId: "MISCELLANEOUS",
    groupLabel: "Miscellaneous",
    privileges: [
      {
        id: HEALTH_STATUS_TAB,
        label: "Server Health",
        desc: "Access to Server Health screen",
      },
      { id: ADD_SYSTEM_TAB, label: "System", desc: "Access to System screen" },
      {
        id: GENERATE_OTP_TAB,
        label: "Generate OTP",
        desc: "Access to Generate OTP screen",
      },
      {
        id: CONFIGURATION_TAB,
        label: "Configuration",
        desc: "Access to Configuration screen",
      },
    ],
  },
  {
    groupId: "STOCK_AUDIT",
    groupLabel: "Stock Audit",
    privileges: [
      {
        id: STOCK_AUDIT_TAB,
        label: "Stock Audit",
        desc: "Access to Stock Audit screen",
      },
      {
        id: REPORTS_STOCK_AUDIT,
        label: "Stock Audit Report",
        desc: "Access to Stock Audit Report screen",
      },
    ],
  },
  {
    groupId: "REPORTS",
    groupLabel: "Reports",
    privileges: [
      {
        id: REPORTS_STOCK_TRANSFER,
        label: "Stock Transfer Report",
        desc: "Access to Stock Transfer Report screen",
      },
      {
        id: REPORTS_STOCK_REQUEST,
        label: "Stock Request Report",
        desc: "Access to Stock Request Report screen",
      },
      {
        id: REPORTS_MEDICINE_WISE_STOCK_AUDIT,
        label: "Medicine Wise Stock Audit Report",
        desc: "Access to Medicine Wise Stock Audit Report screen",
      },
      {
        id: REPORTS_MEDICINE_WISE_STOCK_TRANSFER,
        label: "Medicine Wise Stock Transfer Report",
        desc: "Access to Medicine Wise Stock Transfer Report screen",
      },
      {
        id: REPORTS_MEDICINE_WISE_STOCK_REQUEST,
        label: "Medicine Wise Stock Request Report",
        desc: "Access to Medicine Wise Stock Request Report screen",
      },
      {
        id: REPORTS_DISCOUNT_SLAB,
        label: "Discount Slab Report",
        desc: "Access to Discount Slab Report screen",
      },
      {
        id: REPORTS_DISCOUNT_PROGRAM,
        label: "Discount Program Report",
        desc: "Access to Discount Program Report screen",
      },
      {
        id: REPORTS_FREQUENCY_SLAB_TAB,
        label: "Frequency Slab Report",
        desc: "Access to Frequency Slab Report screen",
      },
    ],
  },
];

export const DEFAULT_ACCESS_TAB_IDS = [RETAILER_REPORTS_TAB];

export const isDefaultAccessTab = (tabId) =>
  DEFAULT_ACCESS_TAB_IDS.includes(tabId);

export const isAdminCacUser = (user) =>
  (user?.username || "").toLowerCase() === "admin";

export const getAllPrivilegeIds = () =>
  privilege_groups.flatMap((group) =>
    group.privileges.map((privilege) => privilege.id)
  );

export const initial_state_cac_roles = {
  type: CAC_ROLES_TAB,
  label: "CAC Users Roles",
  allowMultipleTabs: false,
};

export const userAccessColDefsForExport = [
  {
    headerName: "User Name",
    field: "username",
    maxWidth: 200,
  },
  {
    headerName: "Company",
    field: "company",
    maxWidth: 200,
  },
  {
    headerName: "Access",
    field: "access",
  },
];
